import Navbar from "./Components/Navbar";
import Home from "./Components/Home";
import Why from "./Components/Why";
import Price from "./Components/Price";
import Overview from "./Components/Overview";
import Certificate from "./Components/Certificate";
import Footer from "./Components/Footer";

function App() {
  return (
    <>
      <Navbar />
      <Home />
      <Why />
      <Price />
      <Overview />
      <Certificate />
      <Footer />
    </>
  );
}

export default App;
